"use client";

import Logo from "@features/iTICKET-logo";
import { AnalyticsPage } from "@components/analytics";
import { HOST } from "@utils/constants";
import SignInForm from "@features/account/components/signInForm";
import { Heading, Text, Button } from "@components/theming";
import { SearchParams } from "@models/utils";
import { useTranslations } from "next-intl";
import { joinClassNames } from "@utils/helpers";
import { useIsShopsite } from "@context/DomainContext";

export default function SignIn({
  searchParams,
}: {
  searchParams: SearchParams;
}) {
  const t = useTranslations("SignIn");
  const signUpTranslations = useTranslations("SignUp");
  const isShopsite = useIsShopsite();
  const redirectTo = searchParams["redirectTo"];

  return (
    <>
      <div className="flex flex-col items-center justify-center w-full gap-8">
        <div className="flex items-center justify-center rounded-full bg-red-500 h-20 w-20">
          <Logo size="16" />
        </div>
        <div className="flex flex-col w-full gap-8">
          <div className="flex flex-col gap-4">
            <Heading
              as="h1"
              size="5"
              shopsiteClasses="text-lg text-black font-medium"
            >
              {t("notamember")}
            </Heading>
            <Button
              className="w-full"
              size="3"
              href={{ pathname: "/account/sign-up", query: searchParams }}
            >
              {signUpTranslations("signup")}
            </Button>
          </div>
          <div className="flex items-center gap-2">
            <div
              className={joinClassNames(
                "relative w-full border-t flex-1",
                isShopsite
                  ? "border-t-gray-400"
                  : "border-t-[color:var(--gray-a5)]"
              )}
            />
            <Text
              color="gray"
              align="center"
              sharedClasses="w-fit"
              shopsiteClasses="text-gray-500"
            >
              {t("or")}
            </Text>
            <div
              className={joinClassNames(
                "relative w-full border-t flex-1",
                isShopsite
                  ? "border-t-gray-400"
                  : "border-t-[color:var(--gray-a5)]"
              )}
            />
          </div>
          <div className="flex flex-col w-full gap-4">
            <Heading
              as="h1"
              size="5"
              shopsiteClasses="text-lg text-black font-medium"
            >
              {t("signinpassword")}
            </Heading>
            <SignInForm redirectTo={redirectTo as string | undefined} />
          </div>
        </div>
      </div>
      <AnalyticsPage
        properties={{
          path: `/account/sign-in`,
          title: "Sign In",
          url: `${HOST}/account/sign-in`,
        }}
      />
    </>
  );
}
